

(function () {
  'use strict';

  
  if (window.__veeryCarruselReady) return;
  window.__veeryCarruselReady = true;

  
  var NS = '__vcarControlador';

  

  
  function prefijo(root) {
    return root.getAttribute('data-vcar-prefix') || 'vcar';
  }

  
  function obtenerPista(root) {
    return root.querySelector('[data-vcar-pista]');
  }

  
  var consultas = {};
  function cumple(consulta) {
    if (!consultas[consulta]) consultas[consulta] = window.matchMedia(consulta);
    return consultas[consulta].matches;
  }

  function anchoMinimo(px) {
    return cumple('(min-width: ' + px + 'px)');
  }

  function movimientoReducido() {
    return cumple('(prefers-reduced-motion: reduce)');
  }

  function esLandscapeMobile() {
    return cumple('(orientation: landscape) and (max-height: 599.98px) and (max-width: 989.98px)');
  }

  

  
  function columnasVisiblesReales(root) {
    if (esLandscapeMobile()) return 2;
    var n;
    if (anchoMinimo(990)) n = root.getAttribute('data-vcar-cols-desktop');
    else if (anchoMinimo(749)) n = root.getAttribute('data-vcar-cols-tablet');
    else n = root.getAttribute('data-vcar-cols-mobile');
    n = parseInt(n || '0', 10);
    if (!n || n < 1) n = 1;
    return n;
  }

  
  function gapReal(pista) {
    var cs = window.getComputedStyle(pista);
    var gap = parseFloat(cs.columnGap);
    if (isNaN(gap)) gap = parseFloat(cs.gap) || 0;
    return gap || 0;
  }

  
  function anchoCardReal(root, pista) {
    var item = pista.querySelector('.' + prefijo(root) + '__item');
    return item ? item.getBoundingClientRect().width : 0;
  }

  
  function esCarruselGridMovil(root) {
    return !anchoMinimo(749) &&
      root.classList.contains(prefijo(root) + '--mobile-carrusel-grid');
  }

  
  function paso(root, pista) {
    var cols = columnasVisiblesReales(root);
    if (esCarruselGridMovil(root)) cols = 2;

    var desde = parseInt(root.getAttribute('data-vcar-paso-pagina') || '', 10);
    if (!isNaN(desde) && anchoMinimo(desde)) {
      var cs = window.getComputedStyle(pista);
      var util = pista.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
      var pagina = util + gapReal(pista);
      if (pagina > 1) return pagina;
    }

    var p = (anchoCardReal(root, pista) + gapReal(pista)) * cols;
    if (!p || p < 1) p = pista.clientWidth * 0.9;
    return p;
  }

  

  
  function esGridMovil(root) {
    if (esLandscapeMobile()) return false;
    return !anchoMinimo(749) &&
      root.classList.contains(prefijo(root) + '--mobile-grid');
  }

  
  function limiteMovil(root) {
    var n = parseInt(root.getAttribute('data-vcar-mobile-limit') || '4', 10);
    if (!n || n < 1) n = 4;
    return n;
  }

  
  function items(root) {
    var pista = obtenerPista(root);
    if (!pista) return [];
    return Array.prototype.slice.call(
      pista.querySelectorAll('.' + prefijo(root) + '__item')
    );
  }

  
  function totalPaginas(root) {
    var total = items(root).length, limite = limiteMovil(root);
    if (total < 1) return 1;
    return Math.ceil(total / limite);
  }

  
  function aplicarPagina(root) {
    var lista = items(root), limite = limiteMovil(root);
    var pagina = root[NS + '_pagina'] || 0;
    var inicio = pagina * limite, fin = inicio + limite;
    var claseFuera = prefijo(root) + '__item--fuera-pagina';
    for (var i = 0; i < lista.length; i++) {
      if (i >= inicio && i < fin) lista[i].classList.remove(claseFuera);
      else lista[i].classList.add(claseFuera);
    }
  }

  
  function paginar(root, direccion) {
    var tp = totalPaginas(root);
    var pagina = root[NS + '_pagina'] || 0;
    pagina += direccion;
    if (pagina < 0) pagina = 0;
    if (pagina > tp - 1) pagina = tp - 1;
    root[NS + '_pagina'] = pagina;
    aplicarPagina(root);
    actualizarEstado(root);
  }

  
  function activarPaginacion(root) {
    root.classList.add(prefijo(root) + '--js-paginado');
    if (typeof root[NS + '_pagina'] !== 'number') root[NS + '_pagina'] = 0;
    aplicarPagina(root);
  }

  
  function desactivarPaginacion(root) {
    root.classList.remove(prefijo(root) + '--js-paginado');
    var lista = items(root);
    var claseFuera = prefijo(root) + '__item--fuera-pagina';
    for (var i = 0; i < lista.length; i++) lista[i].classList.remove(claseFuera);
  }

  
  function sincronizarModo(root) {
    if (esGridMovil(root)) activarPaginacion(root);
    else desactivarPaginacion(root);
  }

  

  

  
  function marcarFlecha(boton, apagada) {
    var valor = apagada ? 'true' : 'false';
    if (boton.getAttribute('aria-disabled') !== valor) boton.setAttribute('aria-disabled', valor);
  }

  
  function flechaApagada(boton) {
    return boton.getAttribute('aria-disabled') === 'true';
  }

  function leerEstado(root) {
    var pista = obtenerPista(root);
    if (!pista) return null;


    if (esGridMovil(root)) {
      var tp = totalPaginas(root);
      var pagina = root[NS + '_pagina'] || 0;
      var hayVarias = tp > 1;
      return { prevApagada: !hayVarias || pagina <= 0, nextApagada: !hayVarias || pagina >= tp - 1 };
    }


    var maxScroll = pista.scrollWidth - pista.clientWidth - 1;
    var puedeScroll = maxScroll > 1;
    var alInicio = pista.scrollLeft <= 1;
    var alFinal  = pista.scrollLeft >= maxScroll;
    return { prevApagada: !puedeScroll || alInicio, nextApagada: !puedeScroll || alFinal };
  }

  function pintarEstado(root, estado) {
    if (!estado) return;
    var prevs = root.querySelectorAll('[data-vcar-prev]');
    var nexts = root.querySelectorAll('[data-vcar-next]');
    for (var i = 0; i < prevs.length; i++) marcarFlecha(prevs[i], estado.prevApagada);
    for (var j = 0; j < nexts.length; j++) marcarFlecha(nexts[j], estado.nextApagada);
  }

  function actualizarEstado(root) {
    pintarEstado(root, leerEstado(root));
  }

  
  function desplazar(root, direccion) {
    if (esGridMovil(root)) { paginar(root, direccion); return; }
    var pista = obtenerPista(root);
    if (!pista) return;
    pista.scrollBy({ left: paso(root, pista) * direccion, behavior: movimientoReducido() ? 'instant' : 'smooth' });
  }

  

  
  function esDesktopCarrusel(root) {
    if (esLandscapeMobile()) return false;
    return anchoMinimo(990) &&
      root.classList.contains(prefijo(root) + '--desktop-carrusel');
  }

  function activarArrastre(root, pista) {
    var px = prefijo(root);
    var abajo = false, arrastrando = false;
    var inicioX = 0, inicioScroll = 0, pointerId = null;
    var UMBRAL = 10, QUIETO = 100, ultimoX = 0, ultimoT = 0, velocidad = 0;
    var inerciaRaf = null, huboArrastre = false;

    function cancelarInercia() {
      if (inerciaRaf) { window.cancelAnimationFrame(inerciaRaf); inerciaRaf = null; }
    }

    
    pista.addEventListener('dragstart', function (ev) {
      if (esDesktopCarrusel(root)) ev.preventDefault();
    });

    pista.addEventListener('pointerdown', function (ev) {
      huboArrastre = false;
      if (ev.pointerType !== 'mouse' || ev.button !== 0 || !esDesktopCarrusel(root)) return;
      cancelarInercia();
      abajo = true; arrastrando = false;
      inicioX = ev.clientX; inicioScroll = pista.scrollLeft; pointerId = ev.pointerId;
      ultimoX = ev.clientX; ultimoT = (window.performance ? performance.now() : Date.now()); velocidad = 0;
    });

    pista.addEventListener('pointermove', function (ev) {
      if (!abajo) return;
      var dx = ev.clientX - inicioX;
      
      if (!arrastrando && Math.abs(dx) > UMBRAL) {
        arrastrando = true; huboArrastre = true;
        pista.classList.add(px + '--arrastrando');
        pista.style.scrollSnapType = 'none'; pista.style.scrollBehavior = 'auto';
        try { pista.setPointerCapture(pointerId); } catch (e) {}
      }
      if (arrastrando) {
        ev.preventDefault(); pista.scrollLeft = inicioScroll - dx;
        var ahora = (window.performance ? performance.now() : Date.now()), dt = ahora - ultimoT;
        if (dt > 0) { velocidad = (ev.clientX - ultimoX) / dt; ultimoX = ev.clientX; ultimoT = ahora; }
      }
    });

    
    function inercia() {
      var v = velocidad * 16;
      function avanzar() {
        v *= 0.95; pista.scrollLeft -= v;
        if (Math.abs(v) > 0.4) { inerciaRaf = window.requestAnimationFrame(avanzar); }
        else { inerciaRaf = null; pista.style.scrollSnapType = ''; pista.style.scrollBehavior = ''; }
      }
      inerciaRaf = window.requestAnimationFrame(avanzar);
    }

    function finArrastre(ev) {
      if (!abajo) return; abajo = false;
      var cancelado = !!ev && ev.type === 'pointercancel';
      if (cancelado) huboArrastre = false;
      if (arrastrando) {
        try { if (pointerId !== null) pista.releasePointerCapture(pointerId); } catch (e) {}
        arrastrando = false; pista.classList.remove(px + '--arrastrando');
        var fin = (window.performance ? performance.now() : Date.now());
        if (cancelado || fin - ultimoT > QUIETO) velocidad = 0;
        if (Math.abs(velocidad) > 0.05 && !movimientoReducido()) inercia();
        else { pista.style.scrollSnapType = ''; pista.style.scrollBehavior = ''; }
      }
      pointerId = null;
    }
    pista.addEventListener('pointerup', finArrastre);
    pista.addEventListener('pointercancel', finArrastre);

    
    pista.addEventListener('click', function (ev) {
      if (huboArrastre) { ev.preventDefault(); ev.stopPropagation(); huboArrastre = false; }
    }, true);
  }

  

  
  function aplicarClaseLandscape(root) {
    var clase = prefijo(root) + '--landscape-mobile';
    if (esLandscapeMobile()) root.classList.add(clase);
    else root.classList.remove(clase);
  }

  
  var observadorComun = null;

  function alCambiarTamano(entradas) {
    var raices = [];
    for (var i = 0; i < entradas.length; i++) {
      var r = entradas[i].target[NS + '_raiz'];
      if (r && raices.indexOf(r) === -1) raices.push(r);
    }
    for (var a = 0; a < raices.length; a++) { aplicarClaseLandscape(raices[a]); sincronizarModo(raices[a]); }
    var estados = [];
    for (var b = 0; b < raices.length; b++) estados.push(leerEstado(raices[b]));
    for (var c = 0; c < raices.length; c++) pintarEstado(raices[c], estados[c]);
  }

  function inicializar(root) {
    if (!root || root[NS]) return;
    root[NS] = true;
    var pista = obtenerPista(root);
    if (!pista) return;

    
    var rafId = null;
    pista.addEventListener('scroll', function () {
      if (rafId) return;
      rafId = window.requestAnimationFrame(function () { rafId = null; actualizarEstado(root); });
    }, { passive: true });

    
    var conObservador = false;
    if (typeof ResizeObserver !== 'undefined') {
      try {
        if (!observadorComun) observadorComun = new ResizeObserver(alCambiarTamano);
        pista[NS + '_raiz'] = root;
        observadorComun.observe(pista); root[NS + '_ro'] = pista; conObservador = true;
      } catch (e) {}
    }
    
    if (typeof MutationObserver !== 'undefined') {
      try {
        var mo = new MutationObserver(function () { actualizarEstado(root); });
        mo.observe(pista, { childList: true }); root[NS + '_mo'] = mo;
      } catch (e) {}
    }

    activarArrastre(root, pista);
    if (conObservador) return;
    window.requestAnimationFrame(function () {
      aplicarClaseLandscape(root);
      sincronizarModo(root);
      actualizarEstado(root);
    });
  }

  
  function inicializarTodos(contexto) {
    var roots = (contexto || document).querySelectorAll('[data-vcar-root]');
    for (var i = 0; i < roots.length; i++) inicializar(roots[i]);
  }

  
  function sincronizarTodos() {
    var roots = document.querySelectorAll('[data-vcar-root]');
    for (var i = 0; i < roots.length; i++) {
      aplicarClaseLandscape(roots[i]);
      sincronizarModo(roots[i]);
      actualizarEstado(roots[i]);
    }
  }

  

  if (!window.__vcarDelegacionRegistrada) {
    window.__vcarDelegacionRegistrada = true;

    
    document.addEventListener('click', function (ev) {
      var btnPrev = ev.target.closest('[data-vcar-prev]');
      var btnNext = ev.target.closest('[data-vcar-next]');
      if (!btnPrev && !btnNext) return;
      var boton = btnPrev || btnNext;
      
      if (flechaApagada(boton)) { ev.preventDefault(); return; }
      var root  = boton.closest('[data-vcar-root]');
      if (!root) return;
      inicializar(root); ev.preventDefault();
      desplazar(root, btnPrev ? -1 : 1);
    });

    
    var resizeRaf = null;
    window.addEventListener('resize', function () {
      if (resizeRaf) return;
      resizeRaf = window.requestAnimationFrame(function () {
        resizeRaf = null;
        sincronizarTodos();
      });
    }, { passive: true });

    
    window.addEventListener('orientationchange', function () {
      setTimeout(sincronizarTodos, 150);
    });
  }

  

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { inicializarTodos(document); });
  } else {
    inicializarTodos(document);
  }

  
  document.addEventListener('shopify:section:load', function (evento) {
    if (!evento.target) return;
    inicializarTodos(evento.target);
  });

  
  document.addEventListener('shopify:section:unload', function (evento) {
    if (!evento.target) return;
    var roots = evento.target.querySelectorAll('[data-vcar-root]');
    for (var i = 0; i < roots.length; i++) {
      var r = roots[i];
      if (r[NS + '_ro'] && observadorComun) { try { observadorComun.unobserve(r[NS + '_ro']); } catch (e) {} }
      if (r[NS + '_mo']) { try { r[NS + '_mo'].disconnect(); } catch (e) {} }
    }
  });
})();
